export const footerLinks = {
  'az-az': [
    {
      title: 'Ən Populyar Məkanlar',
      items: [
        {
          title: 'İstanbul',
          href: 'https://www.wingie.az/flights/to-istanbul/',
        },
        {
          title: 'Moskva',
          href: 'https://www.wingie.az/flights/to-moscow/',
        },
        {
          title: 'Dubai',
          href: 'https://www.wingie.az/flights/to-dubai/',
        },
        {
          title: 'Tbilisi',
          href: 'https://www.wingie.az/flights/to-tbilisi/',
        },
        {
          title: 'Ankara',
          href: 'https://www.wingie.az/flights/to-ankara/',
        },
        {
          title: 'London',
          href: 'https://www.wingie.az/flights/to-london/',
        },
      ],
    },
    {
      title: 'Populyar Ölkələr',
      items: [
        {
          title: 'Türkiyə',
          href: 'https://www.wingie.az/flights/tr-turkey/',
        },
        {
          title: 'Rusiya',
          href: 'https://www.wingie.az/flights/ru-russia/',
        },
        {
          title: 'Birləşmiş Arəb Amirlikləri',
          href: 'https://www.wingie.az/flights/ae-united-arab-emirates/',
        },
        {
          title: 'Gürcüstan',
          href: 'https://www.wingie.az/flights/ge-georgia/',
        },
        {
          title: 'Almaniya',
          href: 'https://www.wingie.az/flights/de-germany/',
        },
        {
          title: 'Böyük Britaniya',
          href: 'https://www.wingie.az/flights/gb-united-kingdom/',
        },
      ],
    },
    {
      title: 'Populyar Hava Yolları',
      items: [
        {
          title: 'AZAL',
          href: 'https://www.wingie.az/flights/airlines/azerbaijan-airlines/',
        },
        {
          title: 'Türk Hava Yolları',
          href: 'https://www.wingie.az/flights/airlines/turkish-airlines/',
        },
        {
          title: 'Aeroflot',
          href: 'https://www.wingie.az/flights/airlines/aeroflot/',
        },
        {
          title: 'Buta Airways',
          href: 'https://www.wingie.az/flights/airlines/buta-airways/',
        },
        {
          title: 'Emirates',
          href: 'https://www.wingie.az/flights/airlines/emirates/',
        },
        {
          title: 'Lufthansa',
          href: 'https://www.wingie.az/flights/airlines/lufthansa/',
        },
      ],
    },
  ],
  'az-ru': [
    {
      title: 'Популярные направления',
      items: [
        {
          title: 'Bakü',
          href: 'https://www.wingie.az/flights/to-baku/',
        },
        {
          title: 'Нахчыван',
          href: 'https://www.wingie.az/flights/to-nakchivan/',
        },
        {
          title: 'Гейнджа',
          href: 'https://www.wingie.az/flights/to-ganja/',
        },
        {
          title: 'Стамбул',
          href: 'https://www.wingie.az/flights/to-istanbul/',
        },
        {
          title: 'Анкара',
          href: 'https://www.wingie.az/flights/to-ankara/',
        },
        {
          title: 'Анталия',
          href: 'https://www.wingie.az/flights/to-antalya/',
        },
      ],
    },
    {
      title: 'Популярные страны',
      items: [
        {
          title: 'Беларусь',
          href: 'https://www.wingie.az/flights/by-belarus/',
        },
        {
          title: 'Кипр',
          href: 'https://www.wingie.az/flights/cy-cyprus/',
        },
        {
          title: 'Грузия',
          href: 'https://www.wingie.az/flights/ge-georgia/',
        },
        {
          title: 'Германия',
          href: 'https://www.wingie.az/flights/de-germany/',
        },
        {
          title: 'Венгрия',
          href: 'https://www.wingie.az/flights/hu-hungary/',
        },
        {
          title: 'Казахстан',
          href: 'https://www.wingie.az/flights/kz-kazakhstan/',
        },
      ],
    },
    {
      title: 'Популярные авиакомпании',
      items: [
        {
          title: 'Azerbaijan Airlines',
          href: 'https://www.wingie.az/flights/airlines/azerbaijan-airlines/',
        },
        {
          title: 'Turkish Airlines',
          href: 'https://www.wingie.az/flights/airlines/turkish-airlines/',
        },
        {
          title: 'Pegasus',
          href: 'https://www.wingie.az/flights/airlines/pegasus/',
        },
        {
          title: 'Valuair',
          href: 'https://www.wingie.az/flights/airlines/valuair/',
        },
        {
          title: 'Flynas',
          href: 'https://www.wingie.az/flights/airlines/flynas/',
        },
        {
          title: 'LOT Polish Airlines',
          href: 'https://www.wingie.az/flights/airlines/lot-polish-airlines/',
        },
      ],
    },
  ],
    'az-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    title: 'Las Vegas',
                    href: 'https://www.wingie.az/flights/to-las-vegas/',
                },
                {
                    title: 'Chicago',
                    href: 'https://www.wingie.az/flights/to-chicago/',
                },
                {
                    title: 'Miami',
                    href: 'https://www.wingie.az/flights/to-miami/',
                },
                {
                    title: 'Cancun',
                    href: 'https://www.wingie.az/flights/to-cancun/',
                },
                {
                    title: 'London',
                    href: 'https://www.wingie.az/flights/to-london/',
                },
                {
                    title: 'Honolulu',
                    href: 'https://www.wingie.az/flights/to-honolulu/',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    title: 'Canada',
                    href: 'https://www.wingie.az/flights/ca-canada/',
                },
                {
                    title: 'China',
                    href: 'https://www.wingie.az/flights/cn-china/',
                },
                {
                    title: 'Costa Rica',
                    href: 'https://www.wingie.az/flights/cr-costa-rica/',
                },
                {
                    title: 'Dominican Republic',
                    href: 'https://www.wingie.az/flights/do-dominican-republic/',
                },
                {
                    title: 'El Salvador',
                    href: 'https://www.wingie.az/flights/sv-el-salvador/',
                },
                {
                    title: 'France',
                    href: 'https://www.wingie.az/flights/fr-france/',
                },
            ],
        },
        {
            title: 'Popular Airlines',

            items: [
                {
                    title: 'American Airlines',
                    href: 'https://www.wingie.az/flights/airlines/american-airlines/',
                },
                {
                    title: 'Delta Air lines',
                    href: 'https://www.wingie.az/flights/airlines/delta-air-lines/',
                },
                {
                    title: 'United Airlines',
                    href: 'https://www.wingie.az/flights/airlines/united-airlines/',
                },
                {
                    title: 'Alaska Airlines',
                    href: 'https://www.wingie.az/flights/airlines/alaska-airlines/',
                },
                {
                    title: 'JetBlue',
                    href: 'https://www.wingie.az/flights/airlines/jetblue/',
                },
                {
                    title: 'Hawaiian Airlines',
                    href: 'https://www.wingie.az/flights/airlines/hawaiian-airlines/',
                },
            ],
        },
    ],
    'az-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    title: 'Las Vegas',
                    href: 'https://www.wingie.az/es/vuelos/a-las-vegas/',
                },
                {
                    title: 'Chicago',
                    href: 'https://www.wingie.az/es/vuelos/a-chicago/',
                },
                {
                    title: 'Miami',
                    href: 'https://www.wingie.az/es/vuelos/a-miami/',
                },
                {
                    title: 'Cancun',
                    href: 'https://www.wingie.az/es/vuelos/a-cancun/',
                },
                {
                    title: 'London',
                    href: 'https://www.wingie.az/es/vuelos/a-london/',
                },
                {
                    title: 'Honolulu',
                    href: 'https://www.wingie.az/es/vuelos/a-honolulu/',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    title: 'Canadá',
                    href: 'https://www.wingie.az/es/vuelos/ca-canada/',
                },
                {
                    title: 'China',
                    href: 'https://www.wingie.az/es/vuelos/cn-china/',
                },
                {
                    title: 'Costa Rica',
                    href: 'https://www.wingie.az/es/vuelos/cr-costa-rica/',
                },
                {
                    title: 'República Dominicana',
                    href: 'https://www.wingie.az/es/vuelos/do-dominican-republic/',
                },
                {
                    title: 'El Salvador',
                    href: 'https://www.wingie.az/es/vuelos/sv-el-salvador/',
                },
                {
                    title: 'Francia',
                    href: 'https://www.wingie.az/es/vuelos/fr-france/',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    title: 'American Airlines',
                    href: 'https://www.wingie.az/es/vuelos/companias-aereas/american-airlines/',
                },
                {
                    title: 'Delta Air lines',
                    href: 'https://www.wingie.az/es/vuelos/companias-aereas/delta-air-lines/',
                },
                {
                    title: 'United Airlines',
                    href: 'https://www.wingie.az/es/vuelos/companias-aereas/united-airlines/',
                },
                {
                    title: 'Alaska Airlines',
                    href: 'https://www.wingie.az/es/vuelos/companias-aereas/alaska-airlines/',
                },
                {
                    title: 'JetBlue',
                    href: 'https://www.wingie.az/es/vuelos/companias-aereas/jetblue/',
                },
                {
                    title: 'Hawaiian Airlines',
                    href: 'https://www.wingie.az/es/vuelos/companias-aereas/hawaiian-airlines/',
                },
            ],
        },
    ],
    'az-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.az/de/flug/nach-las-vegas/',
                    title: 'Las Vegas',
                },
                {
                    href: 'https://www.wingie.az/de/flug/nach-chicago/',
                    title: 'Chicago',
                },
                {
                    href: 'https://www.wingie.az/de/flug/nach-miami/',
                    title: 'Miami',
                },
                {
                    href: 'https://www.wingie.az/de/flug/nach-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://www.wingie.az/de/flug/nach-london/',
                    title: 'London',
                },
                {
                    href: 'https://www.wingie.az/de/flug/nach-honolulu/',
                    title: 'Honolulu',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.az/de/flug/ca-kanada/',
                    title: 'Kanada',
                },
                {
                    href: 'https://www.wingie.az/de/flug/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://www.wingie.az/de/flug/cr-costa-rica/',
                    title: 'Costa Rica',
                },
                {
                    href: 'https://www.wingie.az/de/flug/do-dominikanische-republik/',
                    title: 'Dominikanische Republik',
                },
                {
                    href: 'https://www.wingie.az/de/flug/sv-el-salvador/',
                    title: 'El Salvador',
                },
                {
                    href: 'https://www.wingie.az/de/flug/fr-frankreich/',
                    title: 'Frankreich',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.az/de/flug/airlines/american-airlines/',
                    title: 'American Airlines',
                },
                {
                    href: 'https://www.wingie.az/de/flug/airlines/delta-air-lines/',
                    title: 'Delta Air Lines',
                },
                {
                    href: 'https://www.wingie.az/de/flug/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://www.wingie.az/de/flug/airlines/alaska-airlines/',
                    title: 'Alaska Airlines',
                },
                {
                    href: 'https://www.wingie.az/de/flug/airlines/jetblue/',
                    title: 'JetBlue',
                },
                {
                    href: 'https://www.wingie.az/de/flug/airlines/hawaiian-airlines/',
                    title: 'Hawaiian Airlines',
                },
            ],
        },
    ],
    'az-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.az/ar/flights/to-las-vegas/',
                    title: 'لاس فيغاس',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/to-chicago/',
                    title: 'شيكاغو',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/to-miami/',
                    title: 'ميامي',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/to-cancun/',
                    title: 'كانكون',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/to-london/',
                    title: 'لندن',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/to-honolulu/',
                    title: 'هونولولو',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.az/ar/flights/ca-canada/',
                    title: 'كندا',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/cn-china/',
                    title: 'الصين',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/cr-costa-rica/',
                    title: 'كوستاريكا',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/do-dominican-republic/',
                    title: 'جمهورية الدومينيكان',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/sv-el-salvador/',
                    title: 'السلفادور',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/fr-france/',
                    title: 'فرنسا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.az/ar/flights/airlines/american-airlines/',
                    title: 'الخطوط الجوية الأمريكية\n',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/airlines/delta-air-lines/',
                    title: 'Delta Air Lines',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/airlines/united-airlines/',
                    title: 'الخطوط الجوية المتحدة\n',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/airlines/alaska-airlines/',
                    title: 'Alaska Airlines',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/airlines/jetblue/',
                    title: 'جت بلو ايرلاينز',
                },
                {
                    href: 'https://www.wingie.az/ar/flights/airlines/hawaiian-airlines/',
                    title: 'Hawaiian Airlines',
                },
            ],
        },
    ],
    'az-it': [
        {
            title: 'Principali destinazioni',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/it/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.az/it/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.az/it/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.az/it/flights/to-cancun/' },
                { title: 'Londra', href: 'https://www.wingie.az/it/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/it/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                { title: 'Canada', href: 'https://www.wingie.az/it/flights/ca-canada/' },
                { title: 'Cina', href: 'https://www.wingie.az/it/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.az/it/flights/cr-costa-rica/' },
                { title: 'Repubblica Dominicana', href: 'https://www.wingie.az/it/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.az/it/flights/sv-el-salvador/' },
                { title: 'Francia', href: 'https://www.wingie.az/it/flights/fr-france/' },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/it/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/it/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/it/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/it/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/it/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/it/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-fr': [
        {
            title: 'Principales destinations',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/fr/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.az/fr/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.az/fr/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.az/fr/flights/to-cancun/' },
                { title: 'Londres', href: 'https://www.wingie.az/fr/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/fr/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                { title: 'Canada', href: 'https://www.wingie.az/fr/flights/ca-canada/' },
                { title: 'Chine', href: 'https://www.wingie.az/fr/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.az/fr/flights/cr-costa-rica/' },
                { title: 'République dominicaine', href: 'https://www.wingie.az/fr/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.az/fr/flights/sv-el-salvador/' },
                { title: 'France', href: 'https://www.wingie.az/fr/flights/fr-france/' },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/fr/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/fr/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/fr/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/fr/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/fr/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/fr/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-pt': [
        {
            title: 'Principais destinos',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/pt/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.az/pt/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.az/pt/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.az/pt/flights/to-cancun/' },
                { title: 'Londres', href: 'https://www.wingie.az/pt/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/pt/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Países populares',
            items: [
                { title: 'Canadá', href: 'https://www.wingie.az/pt/flights/ca-canada/' },
                { title: 'China', href: 'https://www.wingie.az/pt/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.az/pt/flights/cr-costa-rica/' },
                { title: 'República Dominicana', href: 'https://www.wingie.az/pt/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.az/pt/flights/sv-el-salvador/' },
                { title: 'França', href: 'https://www.wingie.az/pt/flights/fr-france/' },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/pt/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/pt/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/pt/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/pt/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/pt/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/pt/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-ro': [
        {
            title: 'Top destinații',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/ro/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.az/ro/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.az/ro/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.az/ro/flights/to-cancun/' },
                { title: 'Londra', href: 'https://www.wingie.az/ro/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/ro/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                { title: 'Canada', href: 'https://www.wingie.az/ro/flights/ca-canada/' },
                { title: 'China', href: 'https://www.wingie.az/ro/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.az/ro/flights/cr-costa-rica/' },
                { title: 'Republica Dominicană', href: 'https://www.wingie.az/ro/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.az/ro/flights/sv-el-salvador/' },
                { title: 'Franța', href: 'https://www.wingie.az/ro/flights/fr-france/' },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/ro/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/ro/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/ro/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/ro/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/ro/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/ro/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-pl': [
        {
            title: 'Najpopularniejsze kierunki',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/pl/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.az/pl/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.az/pl/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.az/pl/flights/to-cancun/' },
                { title: 'Londyn', href: 'https://www.wingie.az/pl/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/pl/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.az/pl/flights/ca-canada/' },
                { title: 'Chiny', href: 'https://www.wingie.az/pl/flights/cn-china/' },
                { title: 'Kostaryka', href: 'https://www.wingie.az/pl/flights/cr-costa-rica/' },
                { title: 'Dominikana', href: 'https://www.wingie.az/pl/flights/do-dominican-republic/' },
                { title: 'Salwador', href: 'https://www.wingie.az/pl/flights/sv-el-salvador/' },
                { title: 'Francja', href: 'https://www.wingie.az/pl/flights/fr-france/' },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/pl/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/pl/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/pl/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/pl/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/pl/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/pl/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-lt': [
        {
            title: 'Populiariausi maršrutai',
            items: [
                { title: 'Las Vegasas', href: 'https://www.wingie.az/lt/flights/to-las-vegas/' },
                { title: 'Čikaga', href: 'https://www.wingie.az/lt/flights/to-chicago/' },
                { title: 'Majamis', href: 'https://www.wingie.az/lt/flights/to-miami/' },
                { title: 'Kankūnas', href: 'https://www.wingie.az/lt/flights/to-cancun/' },
                { title: 'Londonas', href: 'https://www.wingie.az/lt/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/lt/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.az/lt/flights/ca-kanada/' },
                { title: 'Kinija', href: 'https://www.wingie.az/lt/flights/cn-kinija/' },
                { title: 'Kosta Rika', href: 'https://www.wingie.az/lt/flights/cr-kosta-rika/' },
                { title: 'Dominikos Respublika', href: 'https://www.wingie.az/lt/flights/do-dominican-republic/' },
                { title: 'Salvadoras', href: 'https://www.wingie.az/lt/flights/sv-el-salvador/' },
                { title: 'Prancūzija', href: 'https://www.wingie.az/lt/flights/fr-prancuzija/' },
            ],
        },
        {
            title: 'Populiarios oro linijos',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/lt/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/lt/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/lt/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/lt/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/lt/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/lt/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-uz': [
        {
            title: "Mashhur yo'nalishlar",
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/uz/flights/to-las-vegas/' },
                { title: 'Chikago', href: 'https://www.wingie.az/uz/flights/to-chicago/' },
                { title: 'Mayami', href: 'https://www.wingie.az/uz/flights/to-miami/' },
                { title: 'Kankun', href: 'https://www.wingie.az/uz/flights/to-cancun/' },
                { title: 'London', href: 'https://www.wingie.az/uz/flights/to-london/' },
                { title: 'Gonolulu', href: 'https://www.wingie.az/uz/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Mashhur mamlakatlar',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.az/uz/flights/ca-kanada/' },
                { title: 'Xitoy', href: 'https://www.wingie.az/uz/flights/cn-xitoy/' },
                { title: 'Kosta-Rika', href: 'https://www.wingie.az/uz/flights/cr-kosta-rika/' },
                { title: 'Dominikan Respublikasi', href: 'https://www.wingie.az/uz/flights/do-dominican-republic/' },
                { title: 'Salvador', href: 'https://www.wingie.az/uz/flights/sv-el-salvador/' },
                { title: 'Fransiya', href: 'https://www.wingie.az/uz/flights/fr-fransiya/' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/uz/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/uz/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/uz/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/uz/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/uz/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/uz/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-sr': [
        {
            title: 'Najpopularniji pravci',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/sr/flights/to-las-vegas/' },
                { title: 'Čikago', href: 'https://www.wingie.az/sr/flights/to-chicago/' },
                { title: 'Majami', href: 'https://www.wingie.az/sr/flights/to-miami/' },
                { title: 'Kankun', href: 'https://www.wingie.az/sr/flights/to-cancun/' },
                { title: 'London', href: 'https://www.wingie.az/sr/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/sr/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Popularne zemlje',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.az/sr/flights/ca-kanada/' },
                { title: 'Kina', href: 'https://www.wingie.az/sr/flights/cn-kina/' },
                { title: 'Kostarika', href: 'https://www.wingie.az/sr/flights/cr-kostarika/' },
                { title: 'Dominikanska Republika', href: 'https://www.wingie.az/sr/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.az/sr/flights/sv-el-salvador/' },
                { title: 'Francuska', href: 'https://www.wingie.az/sr/flights/fr-francuska/' },
            ],
        },
        {
            title: 'Popularne avio-kompanije',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/sr/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/sr/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/sr/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/sr/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/sr/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/sr/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-ky': [
        {
            title: 'Эң популярдуу багыттар',
            items: [
                { title: 'Лас Вегас', href: 'https://www.wingie.az/ky/flights/to-las-vegas/' },
                { title: 'Чикаго', href: 'https://www.wingie.az/ky/flights/to-chicago/' },
                { title: 'Майами', href: 'https://www.wingie.az/ky/flights/to-miami/' },
                { title: 'Канкун', href: 'https://www.wingie.az/ky/flights/to-cancun/' },
                { title: 'Лондон', href: 'https://www.wingie.az/ky/flights/to-london/' },
                { title: 'Гонолулу', href: 'https://www.wingie.az/ky/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { title: 'Канада', href: 'https://www.wingie.az/ky/flights/ca-canada/' },
                { title: 'Кытай', href: 'https://www.wingie.az/ky/flights/cn-china/' },
                { title: 'Коста-Рика', href: 'https://www.wingie.az/ky/flights/cr-costa-rica/' },
                { title: 'Доминиканская Республика', href: 'https://www.wingie.az/ky/flights/do-dominican-republic/' },
                { title: 'Сальвадор', href: 'https://www.wingie.az/ky/flights/sv-el-salvador/' },
                { title: 'Франция', href: 'https://www.wingie.az/ky/flights/fr-france/' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/ky/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/ky/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/ky/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/ky/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/ky/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/ky/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-tg': [
        {
            title: 'Самые популярные направления',
            items: [
                { title: 'Лас-Вегас', href: 'https://www.wingie.az/tg/flights/to-las-vegas/' },
                { title: 'Чикаго', href: 'https://www.wingie.az/tg/flights/to-chicago/' },
                { title: 'Майами', href: 'https://www.wingie.az/tg/flights/to-miami/' },
                { title: 'Канкун', href: 'https://www.wingie.az/tg/flights/to-cancun/' },
                { title: 'Лондон', href: 'https://www.wingie.az/tg/flights/to-london/' },
                { title: 'Гонолулу', href: 'https://www.wingie.az/tg/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                { title: 'Канада', href: 'https://www.wingie.az/tg/flights/ca-canada/' },
                { title: 'Чин', href: 'https://www.wingie.az/tg/flights/cn-china/' },
                { title: 'Коста-Рика', href: 'https://www.wingie.az/tg/flights/cr-costa-rica/' },
                { title: 'Ҷумҳурии Доминикан', href: 'https://www.wingie.az/tg/flights/do-dominican-republic/' },
                { title: 'Эл Салвадор', href: 'https://www.wingie.az/tg/flights/sv-el-salvador/' },
                { title: 'Франция', href: 'https://www.wingie.az/tg/flights/fr-france/' },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/tg/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/tg/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/tg/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/tg/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/tg/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/tg/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-kk': [
        {
            title: 'Ең танымал бағыттар',
            items: [
                { title: 'Лас-Вегас', href: 'https://www.wingie.az/kk/flights/to-las-vegas/' },
                { title: 'Чикаго', href: 'https://www.wingie.az/kk/flights/to-chicago/' },
                { title: 'Майами', href: 'https://www.wingie.az/kk/flights/to-miami/' },
                { title: 'Канкун', href: 'https://www.wingie.az/kk/flights/to-cancun/' },
                { title: 'Лондон', href: 'https://www.wingie.az/kk/flights/to-london/' },
                { title: 'Гонолулу', href: 'https://www.wingie.az/kk/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { title: 'Канада', href: 'https://www.wingie.az/kk/flights/ca-canada/' },
                { title: 'Қытай', href: 'https://www.wingie.az/kk/flights/cn-china/' },
                { title: 'Коста-Рика', href: 'https://www.wingie.az/kk/flights/cr-costa-rica/' },
                { title: 'Доминиканская Республика', href: 'https://www.wingie.az/kk/flights/do-dominican-republic/' },
                { title: 'Сальвадор', href: 'https://www.wingie.az/kk/flights/sv-el-salvador/' },
                { title: 'Франция', href: 'https://www.wingie.az/kk/flights/fr-france/' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/kk/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/kk/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/kk/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/kk/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/kk/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/kk/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-nl': [
        {
            title: 'Topbestemmingen',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.az/nl/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.az/nl/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.az/nl/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.az/nl/flights/to-cancun/' },
                { title: 'Londen', href: 'https://www.wingie.az/nl/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.az/nl/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { title: 'Canada', href: 'https://www.wingie.az/nl/flights/ca-canada/' },
                { title: 'China', href: 'https://www.wingie.az/nl/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.az/nl/flights/cr-costa-rica/' },
                { title: 'Dominicaanse Republiek', href: 'https://www.wingie.az/nl/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.az/nl/flights/sv-el-salvador/' },
                { title: 'Frankrijk', href: 'https://www.wingie.az/nl/flights/fr-france/' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.az/nl/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.az/nl/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.az/nl/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.az/nl/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/nl/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.az/nl/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.az/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.az/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.az/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.az/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.az/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.az/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.az/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.az/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.az/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.az/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.az/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.az/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.az/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.az/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.az/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.az/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.az/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.az/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.az/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.az/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.az/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.az/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.az/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.az/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.az/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.az/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.az/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.az/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.az/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.az/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.az/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.az/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.az/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.az/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.az/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.az/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.az/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.az/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.az/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.az/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.az/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.az/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.az/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.az/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.az/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.az/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.az/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.az/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.az/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.az/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.az/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.az/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.az/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.az/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.az/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.az/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.az/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.az/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.az/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.az/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.az/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.az/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.az/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.az/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.az/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.az/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.az/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.az/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.az/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.az/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.az/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.az/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.az/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.az/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.az/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.az/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.az/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.az/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.az/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.az/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.az/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.az/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.az/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.az/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.az/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.az/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.az/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.az/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.az/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.az/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.az/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.az/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.az/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.az/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.az/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.az/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.az/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.az/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.az/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.az/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.az/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.az/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.az/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.az/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.az/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.az/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.az/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.az/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.az/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.az/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.az/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.az/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.az/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.az/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.az/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.az/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.az/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.az/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.az/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'az-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.az/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.az/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.az/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.az/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.az/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.az/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.az/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.az/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.az/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.az/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.az/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.az/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.az/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.az/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.az/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.az/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.az/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.az/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}